import { useLocation } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { META_ADS_TABS, metaAdsActiveTab } from "@/lib/ads/metaAdsTabs";

export function MetaAdsPageSkeleton({ rows = 8 }: { rows?: number }) {
  const location = useLocation();
  const activeTab = metaAdsActiveTab(new URLSearchParams(location.search).get("tab"));

  return (
    <div
      className="flex h-full min-w-0 flex-col overflow-hidden bg-white"
      aria-busy="true"
      aria-label="Loading Meta Ads"
      data-testid="meta-ads-page-skeleton"
    >
      <div className="shrink-0 border-b border-[#EAECF0] px-4 pt-3">
        <div className="flex items-end justify-between gap-3">
          <div className="flex items-end gap-1 overflow-x-auto overflow-y-hidden scrollbar-hide">
            {META_ADS_TABS.map(({ value, label }) => {
              const active = activeTab === value;
              return (
                <span
                  key={value}
                  className={cn(
                    "relative inline-flex items-center whitespace-nowrap px-3 pb-3 pt-2 text-[13.5px] font-semibold",
                    active ? "text-[#101828]" : "text-[#6B7280]",
                  )}
                >
                  {label}
                  {active ? (
                    <span aria-hidden className="absolute bottom-[-1px] left-3 right-3 h-[2px] rounded-t bg-[#0EB64F]" />
                  ) : null}
                </span>
              );
            })}
          </div>
          <div className="flex shrink-0 items-center gap-2 pb-2">
            <Skeleton className="h-9 w-24 rounded-lg" />
            <Skeleton className="h-9 w-36 rounded-lg" />
            <Skeleton className="h-9 w-28 rounded-lg" />
          </div>
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-hidden px-4 py-3">
        <div className="flex flex-wrap items-center gap-2">
          <Skeleton className="h-9 w-full max-w-[260px] rounded-lg" />
          <Skeleton className="h-9 w-20 rounded-lg" />
          <Skeleton className="h-9 w-24 rounded-lg" />
          <Skeleton className="h-9 w-24 rounded-lg" />
        </div>
        <div className="mt-3 space-y-3">
          {Array.from({ length: rows }).map((_, i) => (
            <Skeleton key={i} className="h-14 w-full rounded-lg" />
          ))}
        </div>
      </div>
    </div>
  );
}
